import { EventPanelFormType, EventPanelMetadata } from '@mark43/cad-api';
import { useCallback } from 'react';
import { useEventMetadataStore } from '../event-panel/event-panel-form/event-metadata';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { FrPageHeader } from '../fr-page-layout/fr-page-header';
import { getCreateEventFormTitle } from './helpers';
import { useCreateEventFormPrefill } from './hooks';

export function FrCreateOrEditEventHeader() {
    const { agencyEventNumber, eventId } =
        useEventMetadataStore()?.state?.metadata ?? ({} as EventPanelMetadata);
    const { createEventCallForServicePrefillOptionLabel } = useCreateEventFormPrefill();
    const { form } = useIntegratedForm<EventPanelFormType>();

    const onGoBack = useCallback(() => {
        form.reset();
    }, [form]);

    return (
        <FrPageHeader
            showGoBackButton
            onGoBack={onGoBack}
            title={
                eventId && agencyEventNumber
                    ? `Edit Event #${agencyEventNumber}`
                    : getCreateEventFormTitle(createEventCallForServicePrefillOptionLabel)
            }
        />
    );
}
